import 'es6-promise/auto'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.scss'

// Content & Translations
import content from './content'

// Mixins
import uiStore from './mixins/uiStore'
import questionsStore from './mixins/questionsStore'
import googleAnalytics from './mixins/googleAnalytics'
import translations from './mixins/translations'

// Directives
import clickOutside from './directives/clickOutside'
import routingAnimation from './directives/routingAnimation'
import multilineAnswer from './directives/multilineAnswer'

Vue.config.productionTip = false

Vue.use(content)
Vue.use(VueScrollTo)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAb-2v1rFFwt6s0gxPn7-PrP4Q-1DD67KI',
        libraries: 'places,geometry'
    }
})

Vue.directive('click-outside', clickOutside)
Vue.directive('routing-animation', routingAnimation)
Vue.directive('multiline-answer', multilineAnswer)

Vue.mixin(uiStore)
Vue.mixin(questionsStore)
Vue.mixin(googleAnalytics)
Vue.mixin(translations)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
